import React from 'react';
import AdminOrders from '../components/Admin/AdminOrders';

const AdminOrdersPage = () => {
  return <AdminOrders />;
};

export default AdminOrdersPage;